import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { Answer, Question } from '../../store/form/types';
import { getCompositeAnswerId } from '../../helpers/answers';
import { isEmptyAnswer } from '../../helpers/form';
import UploadFilename from '../UploadFilename/UploadFilename';
import styled from 'styled-components';

interface Props extends GridCellProps {
  question: Question;
  answerById: { [key: string]: Answer };
}

const QuestionCell: React.FC<Props> = ({ question, answerById, ...props }) => {
  const field = props.field || '';
  const value = props.dataItem[field] || '';

  const id = getCompositeAnswerId(question.id, props.dataItem.id);
  const answer = answerById[id];

  const getInputComponent = () => {
    switch (question.type) {
      case 'FileUpload':
        if (isEmptyAnswer(answer)) {
          return undefined;
        } else {
          const fileUpload = answer.answer?.value as FileUpload;
          return <StyledUploadFilename filename_original={fileUpload.filename_original} path={fileUpload.path} />;
        }
      default:
        return value;
    }
  };

  return (
    <td
      colSpan={props.colSpan}
      className={props.className}
      role="gridcell"
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      style={props.style}
    >
      {getInputComponent()}
    </td>
  );
};

const StyledUploadFilename = styled(UploadFilename)`
  display: flex;
  align-items: flex-start;
`;

export default QuestionCell;
